import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
          <div className="flex items-center gap-1">
            <div className="leading-tight">
              <div className="font-display text-lg font-bold">Computer Hellen</div>
              <div className="text-xs text-muted-foreground">IT Dienstleistungen seit 2004</div>
            </div>
            <img src="/assets/logo-mouse.png" alt="Computer Hellen" className="h-11 w-auto -ml-4 -mt-3" />
          </div>
            <p className="mt-3 text-sm text-muted-foreground max-w-xs">
              Ihr persönlicher Partner rund um IT, Netzwerke und Telekommunikation am Niederrhein – seit 2004.
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground/70">
              Kontakt
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span>Dinkelweg 21<br />47638 Straelen</span>
              </li>
              <li>
                <a href="tel:028349448700" className="flex items-center gap-2 hover:text-primary" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-primary" /> 02834 9448700
                </a>
              </li>
              <li>
                <a href="mailto:info@computerhellen.de" className="flex items-center gap-2 hover:text-primary" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-primary" /> info@computerhellen.de
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground/70">
              Rechtliches
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/impressum" className="hover:text-primary" data-testid="footer-impressum-link">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="hover:text-primary" data-testid="footer-datenschutz-link">
                  Datenschutzerklärung
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-border pt-6 text-xs text-muted-foreground md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Computer Hellen · Dipl.-Ing. Alexander Hellen</span>
          <span>Verantwortlich i.S.d. § 18 Abs. 2 MStV: Alexander Hellen</span>
        </div>
      </div>
    </footer>
  );
}
